import { Button, DropdownMenu } from '@components'
import React from 'react'
import { FaCaretDown } from 'react-icons/fa'

type Props = {
  icon?: React.ReactElement
  label: React.ReactNode
  title?: string
  menuItems: React.ReactElement[]
}

export const ToolbarSplitSelect: React.FC<Props> = ({ icon, label, title, menuItems }) => (
  <DropdownMenu items={menuItems} placement="bottom-start">
    <Button type="button" size="sm" icon={icon} title={title}>
      {label}
      <FaCaretDown style={{ fontSize: 9, color: '#a0aab5', marginLeft: 7 }} />
    </Button>
  </DropdownMenu>
)
